module.exports = __webpack_public_path__ + "img/logo.b639697d.png";